import { LeftCircleOutlined } from "@ant-design/icons";
import { Outlet } from "react-router-dom";
import { Flex, Text } from "../components";
import { useNavigate } from "../hooks";

const SubRouteLayout = () => {
  const { goBack, options } = useNavigate();

  return (
    <div className="min-h-[70vh] bg-background px-page pt-[4rem] pb-[15rem] mobile:pt-[2rem] mobile:pb-[8rem]">
      <Flex gap={"1rem"} align="center" className="m-20-b">
        <Text level={3} type="base">
          <LeftCircleOutlined onClick={goBack} />
        </Text>
        {options.title && <Text level={3} children={options.title} />}
      </Flex>
      <Outlet />
    </div>
  );
};

export default SubRouteLayout;
